<h2 mat-dialog-title class="mat-headline-small">
	{{"Felder zurücksetzen" | translate: ""}}
</h2>
<p mat-dialog-content class="mat-body-medium">
{{"Wollen Sie Ihre individuellen Einstellungen wirklich löschen und die Felder in den Ursprungszustand zurücksetzen?" | translate : ""}}
</p>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">
    {{"Abbrechen" | translate : ""}}
  </button>
  <button mat-button class="button--tertiary" (click)="confirm()">
    {{"Bestätigen" | translate : ""}}
  </button>
</div>